import { RecognitionType } from '../../types/recognition';
import {Card} from '../ui/Card/Card';
import { Heart, Zap } from 'lucide-react';

// defining the props that RecognitionCard will accept
export interface RecentRecognitionCardProps {
    variant: RecognitionType.ShoutOut | RecognitionType.PowerUp;
    description: string;
}

// RecognitionCard component that changes based on the variant prop
export const RecognitionCard = ({variant, description}: RecentRecognitionCardProps) => {
    let Icon, title, colors;
    
    if (variant === RecognitionType.ShoutOut){ 
        Icon = Heart;
        title = 'Shout Out';
        colors = 'text-blue-500 border-blue-200 bg-blue-500/5';
    } else{
        Icon = Zap;
        title = 'Power-Up';
        colors = 'text-orange-500 border-orange-200 bg-orange-500/5';
    }
    
    return(
        <Card className={colors}>
            <div className="flex items-center gap-2">
                <Icon className="size-4" />
                <h3 className="font-semibold text-gray-800 text-sm md:text-base">{title}</h3>
            </div>
            <p className="text-gray-500 mt-3 text-sm leading-relaxed break-words">
                {description}
            </p>
        </Card>
    )
    
}
